import { NumberFormat, Trans } from '@lingui/macro'

import { Box } from 'rebass'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Heading } from 'rebass'
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel'
import MuiTable from '@material-ui/core/Table'
import React from 'react'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import locales from '../utils/locales'
import typography from '../utils/typography'
import { withStyles } from '@material-ui/core/styles'

const ExpansionPanel = withStyles(theme => {
  return {
    root: {
      border: `1px solid rgba(0,0,0,.125)`,
      boxShadow: 'none',
      '&:before': {
        display: 'none',
      },
      '&:not($expanded)': {
        marginTop: -1,
      },
    },
    expanded: {},
  }
})(MuiExpansionPanel)

const Table = withStyles({
  root: {
    fontFamily: typography.options.bodyFontFamily.join(','),
  },
})(MuiTable)

export default class PricingSection extends React.PureComponent {
  render() {
    const { locale, heading, services } = this.props

    return (
      <ExpansionPanel defaultExpanded={!heading}>
        {heading && (
          <ExpansionPanelSummary
            expandIcon={
              <FontAwesomeIcon
                icon="angle-down"
                style={{ width: 24, height: 24 }}
              />
            }
          >
            <Heading as="h3" fontSize={[3, 5]} fontWeight="normal">
              {heading[locale]}
            </Heading>
          </ExpansionPanelSummary>
        )}
        <ExpansionPanelDetails style={{ paddingBottom: 12 }}>
          <Box style={{ width: '100%', overflowX: 'auto' }}>
            <Table style={{ margin: 0 }}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Trans>Úkon</Trans>
                  </TableCell>
                  <TableCell align="right" style={{ paddingRight: 0 }}>
                    <Trans>Cena</Trans>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {services.map(
                  (
                    { price: { from, per_tooth, ...priceByCurrency }, ...item },
                    index
                  ) => {
                    const isLastItem = index === services.length - 1
                    const currency = locales[locale].currency
                    const price = priceByCurrency[currency]

                    return (
                      <TableRow key={item[locale]}>
                        <TableCell
                          style={{ ...(isLastItem ? { border: 0 } : {}) }}
                        >
                          {item[locale]}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            ...(isLastItem ? { border: 0 } : {}),
                            paddingRight: 0,
                          }}
                        >
                          {from && (
                            <>
                              <Trans>od</Trans>{' '}
                            </>
                          )}
                          {price > 0 ? (
                            <NumberFormat
                              value={price}
                              format={{
                                style: 'currency',
                                currency,
                                minimumFractionDigits: 0,
                              }}
                            />
                          ) : (
                            <strong>
                              <Trans>zdarma</Trans>
                            </strong>
                          )}
                          {per_tooth && (
                            <>
                              {' '}
                              <Trans>/ zub</Trans>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  }
                )}
              </TableBody>
            </Table>
          </Box>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    )
  }
}
